"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERMISSION = void 0;
var PERMISSION = {
  COST_APPROVAL: 'COST_APPROVAL',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  COMMENT: 'COMMENT',
  APPROVE: 'APPROVE',
  CREATE: 'CREATE',
  CREATE_CHILDREN: 'CREATE_CHILDREN',
  DELETE_CHILDREN: 'DELETE_CHILDREN',
  SCRIPTS: 'SCRIPTS',
  STORYBOARDS: 'STORYBOARDS',
  DAM: 'DAM',
  ORGANISATION: 'ORGANISATION',
  INTERNAL: 'INTERNAL',
  MANAGE_ORGANISATION: 'MANAGE_ORGANISATION',
  MANAGE_TEAM: 'MANAGE_TEAM',
  MANAGE_CUSTOMERS: 'MANAGE_CUSTOMERS',
  VIDEO_TOOL: 'VIDEO_TOOL',
  VIDEO_REVIEW: 'VIDEO_REVIEW',
  USER_SETTINGS: 'USER_SETTINGS',
  INSPIRATIONS: 'INSPIRATIONS',
  CREATE_INSPIRATION: 'CREATE_INSPIRATION',
  CREATE_FROM_VIDEO: 'CREATE_FROM_VIDEO',
  SOCIAL_APPROVAL: 'SOCIAL_APPROVAL',
  MANAGE_INSPIRATIONS: 'MANAGE_INSPIRATIONS',
  MANAGE_INSPIRATION_CAMPAIGNS: 'MANAGE_INSPIRATION_CAMPAIGNS',
  ARCHIVE: 'ARCHIVE',
  DELETE_ASSET: 'DELETE_ASSET',
  FEATURE_INSPIRATION_POST: 'FEATURE_INSPIRATION_POST',
  APPROVE_INTERNAL: 'APPROVE_INTERNAL',
  CAST: 'CAST',
  GHOSTING: 'GHOSTING'
};
exports.PERMISSION = PERMISSION;